import React from 'react';
import ForDetail from '../ForDetail';
import { motion } from 'framer-motion';
import { useTranslation } from 'react-i18next';
import { containerVariants, textVariants } from '../../script/animation';
import { Link } from 'react-router';

const Section6 = () => {
  const { t } = useTranslation();

  return (
    <motion.div 
      variants={containerVariants}
      initial="hidden"
      whileInView="visible"
      className='w-full bg-red grid grid-cols-11 relative bg-white'
    >
      <div className='col-start-2 col-span-9 lg:col-start-3 lg:col-span-5 z-50 py-20 grid md:gap-10 lg:gap-20 content-center group'>
        <div>
          <motion.img variants={textVariants} src='/images/home-icons/institutional.svg' alt="Institutional Icon" />
          <motion.h1 variants={textVariants} className='text-65 font-extrabold nunito-sans mb-5 text-genesisBlue'>
            {t('section6_title')}
          </motion.h1>
          <motion.p variants={textVariants} className='text-18 text-customGray'>
            {t('section6_description')}
          </motion.p>

          <Link to={'/kurumsal'}>
            <ForDetail />
          </Link>
        </div>
      </div>
    </motion.div>
  );
};

export default Section6;
